/*

	YH: Data Spread Sheet is Here
	https://docs.google.com/spreadsheets/d/18RF7vwKqvJwd7ZKlx4oDoTJSatrjOCZ9_Qh2O49ikhM/edit?usp=sharing

*/

export const News = [

    {
    	id: 1,
    	date: '1 October 2020',
    	category: 'Thought News',
    	img: '/data/news/1.png',
    	img_color: '#eef0ee',
    	img_size: '',
    	ja: {
    		title: 'ブランディングツール Thought<br>2021年夏ごろリリース予定！',
    		body: 'ヘアーサロン、移動店舗、カフェなどのデザイン重視の小規模店のオーナー向けホームページ作成ツール<span class="en">Thought</span>(ソート)を<span class="en">2021</span>年夏ごろリリースします。 手軽に高品質なホームページを作成でき、高品質無料写真素材の利用、世界初のフォントシステムを搭載した、美しいデザインを誰でも表現できます。 リリースまでおまちください。',
    	},
    	en: {
    		title: '',
    		body: '',
    	},
    },

];
